<template lang="pug">
form#manage-budget-form
  div(v-if="!budgetsEnabled && !showDialogLoading")
    AppUpsellBanner(
      :feature="budgetsFeature"
      :organization-id="organization.id"
      :can-manage-billing="canManageBilling"
    )
  fieldset(v-else)
    BudgetsForm(
      ref="budgetsForm"
      allow-stop-timer
      show-members-limit
      extended-reset-options
      allow-notify-all-members
      :organization="organization"
      :duration-format="durationFormat"
      :budget-state="budgetState"
      :members-limits-state="membersLimitsState"
      :has-budget="!!project.has_budget"
      :disabled="!projectActive"
      :selected-toggle="selectedToggle"
      :validation-armed="validationArmed"
      @change-budget-field="handleChangeBudgetField"
      @change-members-limits-field="handleChangeMembersLimitsField"
      @member-added="handleMemberAdded"
      @clear-budget="handleClearBudget"
    )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BudgetsForm from '../budgets/BudgetsForm.vue';

export default {
  name: 'ProjectDialogTabBudgets',
  components: { BudgetsForm },
  props: {
    selectedToggle: {
      type: String,
      default: '',
    },
    // From the dialog: gates the budget's member-limit `required` rules on the first Save
    // (validate-on-click — no premature red when a member is selected before Save).
    validationArmed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['organization', 'project', 'budget', 'members_limits']),
    ...mapGetters([
      'durationFormat',
      'budgetsFeature',
      'budgetsEnabled',
      'canManageBilling',
      'showDialogLoading',
      'projectActive',
    ]),
    budgetState() {
      return this.project.budget || {};
    },
    membersLimitsState() {
      return this.project.members_limits || undefined;
    },
  },
  mounted() {
    if (this.membersLimitsState) {
      this.updateField({ path: 'members_limits', value: this.membersLimitsState });
    }
  },
  methods: {
    ...mapActions(['updateField', 'resetBudget']),
    // Proxy to BudgetsForm so the parent dialog can gate Save / tab errors on the
    // budget validity (its fields live in BudgetsForm's nested observers).
    validate() {
      // No BudgetsForm rendered (upsell banner only) → nothing to validate, treat as valid.
      return this.$refs.budgetsForm?.validate?.() ?? true;
    },
    validateSilently() {
      return this.$refs.budgetsForm?.validateSilently?.() ?? true;
    },
    reset() {
      this.$refs.budgetsForm?.reset?.();
    },
    handleClearBudget() {
      this.resetBudget();
      this.$emit('clearedBudget');
    },
    handleMemberAdded() {
      this.$emit('memberAdded');
    },
    handleChangeMembersLimitsField(field, val) {
      this.updateField({ path: field, value: val });
    },
    handleChangeBudgetField(field, val) {
      this.updateField({ path: `budget.${field}`, value: val });
    },
  },
};
</script>
